import { html, type TemplateResult } from 'lit';
import { MarkdownDoc } from '../../data/markdownEngine';

export interface AppRootProps {
  activeTab: string;
  activeDoc: MarkdownDoc | null;
  posts: MarkdownDoc[];
  projects: MarkdownDoc[];
  investigations: MarkdownDoc[];
  onNavChange: (tab: string) => void;
  onOpenDoc: (doc: MarkdownDoc) => void;
  onBackToList: () => void;
}

export function renderAppRootPresentation(props: AppRootProps): TemplateResult {
  const {
    activeTab,
    activeDoc,
    posts,
    onNavChange,
    onOpenDoc,
    onBackToList,
  } = props;

  let mainBody: TemplateResult;

  if (activeDoc) {
    mainBody = html`
      <post-reader
        .doc=${activeDoc}
        @back-to-list=${onBackToList}
      ></post-reader>
    `;
  } else {
    switch (activeTab) {
      case 'about':
        mainBody = html`<about-view></about-view>`;
        break;
      case 'posts':
        mainBody = html`
          <post-list
            .posts=${posts}
            @open-doc=${(e: CustomEvent) => onOpenDoc(e.detail.doc)}
          ></post-list>
        `;
        break;
      case 'analytics':
        mainBody = html`<analytics-view></analytics-view>`;
        break;
      default:
        mainBody = html`<about-view></about-view>`;
    }
  }

  return html`
    <main class="doc-container">
      ${!activeDoc ? html`<app-header></app-header>` : ''}

      ${!activeDoc
        ? html`
            <app-nav
              .currentTab=${activeTab}
              @nav-change=${(e: CustomEvent) => onNavChange(e.detail.tab)}
            ></app-nav>
          `
        : ''}

      ${mainBody}

      <app-footer></app-footer>
    </main>
  `;
}
